import create from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface InformationState {
  closeInformationDrawer: () => void;
  informationContentKey: Array<string> | null;
  isOpen: boolean;
  openInformationDrawer: (key: Array<string>) => void;
}

const useInformationDrawerStore = create<InformationState>()(
  devtools(
    persist(
      (set) => ({
        closeInformationDrawer: () =>
          set({ informationContentKey: null, isOpen: false }),
        informationContentKey: null,
        isOpen: false,
        openInformationDrawer: (key) =>
          set({ informationContentKey: key, isOpen: true })
      }),
      {
        name: 'Information-storage'
      }
    )
  )
);

export default useInformationDrawerStore;
